import { createContext } from 'react';

import { IOrder, IShipment, IShipmentPayment } from '../../../store/ducks/order/types';

// Type for storing dynamic functions
export type OrderFunction = (...args: any[]) => any;
export type OrderFunctions = Record<string, OrderFunction>;

export interface IOrderContext {
  order: IOrder | null;
  combosSerials: string[];
  setCombosSerials: (serials: string[]) => void;
  shipment: IShipment | null;
  payments: IShipmentPayment[] | null;
  // Dynamic functions storage
  functions: OrderFunctions;
  setFunction: (key: string, fn: OrderFunction) => void;
  useFunction: <T extends OrderFunction>(key: string) => T | undefined;
  removeFunction: (key: string) => void;
}

export const OrderContext = createContext<IOrderContext | null>(null);
